import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["personalizations"];
import { sortByPriority } from 'personalization-lib/utils/sorting';
const mapToPersonalizedAsset = ({
  assetCoordinates,
  targetingConfig,
  priority
}) => ({
  assetCoordinates,
  targetingConfig,
  priority
});
export const getAllStrategyAssets = _ref => {
  let {
      personalizations
    } = _ref,
    mainAsset = _objectWithoutPropertiesLoose(_ref, _excluded);
  return [...sortByPriority(personalizations).map(mapToPersonalizedAsset), {
    assetCoordinates: mainAsset.assetCoordinates,
    targetingConfig: undefined,
    priority: undefined
  }];
};
export const getAssetIds = variants => variants.map(variant => variant.assetCoordinates.id);
export const getAssetDetails = ({
  assetCoordinates
}) => ({
  assetType: assetCoordinates.source,
  assetId: assetCoordinates.id.toString()
});